import { render } from "./RankingTableColorConfiger.vue?vue&type=template&id=312feaf4&scoped=true"
import script from "./RankingTableColorConfiger.vue?vue&type=script&lang=js"
export * from "./RankingTableColorConfiger.vue?vue&type=script&lang=js"

import "./RankingTableColorConfiger.vue?vue&type=style&index=0&id=312feaf4&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-312feaf4"]])

export default __exports__